import { albumData } from '@/mocks/album';

// アカウントを持っていない SNS はアイコンごと出さない（リンク切れを置かないため）。
// album.site.ts の snsLinks に URL を足せば、ここは触らずに復活する。
const SNS = [
  { key: 'twitter', label: 'X', icon: 'ri-twitter-x-fill' },
  { key: 'instagram', label: 'Instagram', icon: 'ri-instagram-fill' },
  { key: 'youtube', label: 'YouTube', icon: 'ri-youtube-fill' },
] as const;

export default function Footer() {
  const links = SNS
    .map((s) => ({ ...s, href: albumData.snsLinks[s.key] }))
    .filter((s) => Boolean(s.href));

  return (
    <footer className="bg-background-100 text-foreground-700 py-12 border-t border-background-300/30">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <p className="font-heading text-foreground-950 text-lg mb-1">Who is the machine?</p>
            <p className="text-xs">
              &copy; {albumData.copyrightYear} {albumData.label} / {albumData.rightsHolder} All rights reserved.
            </p>
            {/* ℗ = フォノグラム権（録音そのもの）。© が楽曲・歌詞を指すのに対し、
                ℗ は録音物を指す。音源リリースでは両方を併記するのが一般的。 */}
            <p className="text-xs">
              ℗ {albumData.copyrightYear} {albumData.label} / {albumData.rightsHolder}
            </p>
          </div>

          {links.length > 0 && (
            <div className="flex items-center gap-4">
              {links.map((s) => (
                <a
                  key={s.key}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-8 h-8 rounded-full bg-background-200/50 hover:bg-background-300/70 flex items-center justify-center transition-colors duration-300 cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-foreground-600 text-sm`}></i>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}